<template>
  <div id="login_page">
    <div class="container">
      <v-logo></v-logo>
      <section class="login_inner pull-right">
        <h4 class="color_5babf4 login_title">账号密码登录</h4>
        <form action="#" method="">
          <div class="user login_mbtm6">
            <label class="label_focus" for="login_user_name">手机号码</label>
            <input type="text" @keyup.enter="login" class="form-control input_focus login_form" id="login_user_name"
                   v-model="username"/>
          </div>
          <div class="password login_mbtm6">
            <label class="label_focus" for="login_psw">密码</label>
            <input type="password" @keyup.enter="login" class="form-control input_focus login_form" id="login_psw"
                   v-model="password"/>
          </div>
          <div class="forget_yzm login_mbtm6">
            <label class="label_focus" for="forget_yzm">验证码</label>
            <input type="text" class="form-control inline-block input_focus login_form" @keyup.enter="login"
                   id="forget_yzm" v-model="yanzm"/>
            <div class="yzm_box inline-block">
              <img id="verifyImg" @click="fleshVerify('verifyImg')"></img>
            </div>
            <i class="glyphicon icon_reload" @click="fleshVerify('verifyImg')" id="cloudFreshenOne"></i>
          </div>
          <p class="tip_box vis-hide denglu">
            <small class="tip_yz">密码错误！</small>
          </p>
          <p class="login_btn_box">
            <a href="javascript:;" class="btn btn_h btn_issue margin_r_7" @click="login()" id="ypt_login">登录</a>
            <router-link to="/forget_page" id="forget_psw_btn" class="color_9">
              <small>忘记密码</small>
            </router-link>
            |
            <router-link to="/register_index" id="register_btn" class="color_308de2">
              <small>立即注册</small>
            </router-link>
          </p>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        trueFlag: false,
        falseFlag: false,
        tipText: '',
        username: '',
        password: '',
        islogin: 1,
        yanzm: '',
        istrue: 0,
        user: {
          mobile: "",
          yzm: ""
        },
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        //输入框聚焦效果
        this.$inputFocus(".input_focus");
        this.fleshVerify('verifyImg');

        localStorage.removeItem("token");
        localStorage.removeItem('loginUserType');
      })
    },
    methods: {
      login() {
        var temp = this;
        var username = this.username;
        var password = this.password;
        var checkCode= this.yanzm;
        if (username.trim() == '') {
          $(".denglu").removeClass("vis-hide");
          $(".tip_yz").text('手机号不能为空');
          return;
        } else if (password.trim() == '') {
          $(".denglu").removeClass("vis-hide");
          $(".tip_yz").text('密码不能为空');
          return;
        }

        if (temp.istrue == 0) {
          $(".denglu").addClass("vis-hide");
          this.$http.post('/zklccloud/weblogin', {
            "username": aesMinEncrypt(username),
            "password": aesMinEncrypt(password),
            "checkCode": checkCode
          }, {emulateJSON: true}).then(function (m) {
            if(m.body.access_token){
              localStorage.setItem("token", m.body.access_token);
              this.$http.post('/zklccloud/findTCloudUser', {"access_token": m.body.access_token}, {emulateJSON: true}).then(function (m) {
                if (m.body.content.userInfo == null) {//说明无角色
                  localStorage.setItem('loginUserType', "unrole");
                  //切换至角色选择
                  this.$router.push({
                    name: 'register_success',
                    params: {isLogin: 1}
                  });
                } else {
                  var userType = new String(m.body.content.userInfo.userType);
                  localStorage.setItem('loginUserType', userType);
                  this.$router.push("/developer_index");
                }
              });
            }

          }, function (err) {
            this.fleshVerify('verifyImg');
            temp.islogin++;
            $(".denglu").removeClass("vis-hide");
            if(err.body.errorMsg=='userError'){
              $(".tip_yz").text('手机号或密码错误');
            }else if(err.body.errorMsg=='userLockError'){
              $(".tip_yz").text('账户被锁定，请稍后再试');
            }else if(err.body.errorMsg=='checkCodeError'){
              this.fleshVerify('verifyImg');
              $(".tip_yz").text('验证码错误');
              this.yanzm="";
            }

            return;
          })
        }
      },
      fleshVerify(obj) {
        //重载验证码
        var verify = document.getElementById(obj);
        if (verify) {
          verify.setAttribute('src', '/zklccloud/captcha.jpg?' + Math.random());
        }

      },
    },
  }
</script>

<style scoped>
  #login_page {
    min-height: 100%;
    background: url(img/bg-login.png) no-repeat center center;
    -webkit-background-size: cover;
    background-size: cover;
  }

  #login_page .container {
    min-height: 550px;
  }

  .login_inner {
    width: 340px;
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// login_page.vue?17eacc93